import React from 'react';
import { ArrowRight } from 'lucide-react';

const WelcomeStep = ({ onNext }) => (
  <div className="mx-auto max-w-xl py-16">
    <p className="label">WELCOME</p>
    <h1 className="mt-6 font-display text-4xl sm:text-5xl leading-tight text-ink-900 dark:text-ink-50">
      읽은 것을<br />읽은 채로 두지 않기
    </h1>
    <p className="mt-8 text-base leading-relaxed text-ink-600 dark:text-ink-300 font-sans">
      문장을 남기고, 생각을 덧붙이고, 완독까지의 페이스를 확인합니다.
      먼저 지금 읽고 있는 책 한 권만 등록해볼까요.
    </p>

    <button onClick={onNext} className="btn-primary mt-10">
      시작하기
      <ArrowRight size={14} strokeWidth={1.5} />
    </button>
  </div>
);

export default WelcomeStep;
